import { splitProps, type JSX } from "solid-js";
import { cn } from "@/shared/ui/utils";
import { t } from "@/shared/i18n";
import { openSettings } from "@/tracking/consent/consentStore";

interface PrivacySettingsLinkProps extends JSX.HTMLAttributes<HTMLButtonElement> {
  class?: string;
}

/**
 * The permanent way back into the consent choices — belongs in the footer of every page.
 *
 * <p>Withdrawing a consent has to be as easy as giving it, and the banner is gone the moment a
 * decision exists. Without this there is no second door: the only remaining route would be clearing
 * site data in the browser, which is not a choice anyone can be expected to find.</p>
 *
 * <p>A real button, not an anchor. It navigates nowhere — it reopens a panel on the page you are
 * already on — and an <c>href="#"</c> that silently does something else is the thing screen-reader
 * users learn to distrust.</p>
 */
export default function PrivacySettingsLink(props: PrivacySettingsLinkProps) {
  const [l, r] = splitProps(props, ["class"]);
  return (
    <button
      // Spread first: a caller passing onClick must not silently replace the one thing this does.
      {...r}
      type="button"
      onClick={() => openSettings()}
      class={cn(
        // py-1.5 keeps the target at least 24px tall (WCAG 2.2 target size) at this font size.
        "inline-flex items-center rounded py-1.5 text-xs underline underline-offset-4 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white",
        l.class,
      )}
    >
      {t("consent.settingsLink", "Personverninnstillinger")}
    </button>
  );
}
